<h1 mat-dialog-title>{{ isNew ? "Add" : "Edit" }} Parameter</h1>
<div mat-dialog-content>
  <div>
    <app-amount-form [substanceAmount]="subsAmount" #amountForm>
    </app-amount-form>
    <div class="actions">
      <span class="middle-fill"></span>
      <button matButton (click)="cancel()">Cancel</button>
      <button matButton [disabled]="!amountForm" (click)="save()">Save</button>
    </div>
  </div>
</div>
